import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslateContext } from "../../contexts/translate.context";
import CondominiumHeader from "../headers/condominium.header";
import EstateCondominiumForm from "./forms/estate.condominium.form";
import EstateCondominiumList from "./lists/estate.condominium.list";
import EstateAllCondominiumForm from "./forms/estate-all-condominium-form";

export interface IEstateCondominiumProps {
    viewOnly?: boolean
}

export const EstateCondominium: React.FC<IEstateCondominiumProps> = (props: IEstateCondominiumProps) => {

    const { estateId } = useParams();
    const { display } = useTranslateContext();

    const title = display.title.estate;
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : estateId || '', selected : ((estateId === 'new') || (estateId === '0') || (!Number.isNaN(Number.parseInt(estateId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
    
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);
    
    return (
        <div className="page">
            {(recordSelected.selected) ? (
                <EstateAllCondominiumForm 
                    title={`${display.title.estate} - ${title}`} 
                    identifier={recordSelected.param}
                    viewOnly={props.viewOnly}
                    tabView={'estate-resident'}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
                        setSelected(false, recordId); 
                    }}
                />
            ) : (
                <>
                <CondominiumHeader title={title} description={description} />
                <EstateCondominiumList
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
                        setSelected(true, recordId); 
                    }}
                    viewOnly={props.viewOnly}
                />
                </>
            )}
        </div>
    )
}

export default EstateCondominium;
